module.exports = __webpack_public_path__ + "media/images/admin/icons/eye-b1238fb7eda76106bcfacd66eeefcaa7.svg";